import { Typography } from '@material-ui/core';
import styled from 'styled-components';

export const StyledContentWrapper = styled.div`
  height: 100%;
  padding: 3rem 2rem 0;
`;

export const StyledHeader = styled(Typography)`
  font-size: 1.3846rem;
  font-weight: 400;
  line-height: 1.6923rem;
  letter-spacing: 0.0231rem;
  text-align: left;
`;

export const StyledButtonContainer = styled.div`
  margin-top: 3rem;
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;
